<template>
    <div>
      <loading 
            :active.sync="isLoading" 
            :opacity="0.8"
            color="#f5365c"
            :is-full-page="true">
        </loading>
        <base-header type="gradient-blue" class="pb-6 pb-8 pt-5 pt-md-8">
            <!-- Card stats -->
            <div class="row">
                <div class="col-xl-4 col-lg-4 col-md-4">
                    <stats-card title="Número de clientes"
                        type="gradient-red"
                        :sub-title="clientsCount"
                        icon="ni ni-satisfied"
                        class="mb-4 mb-xl-0">
                    </stats-card>
                </div>
                <div class="col-xl-8 col-lg-8 col-md-8">
                    <stats-card title="Último cliente agregado"
                        type="gradient-red"
                        :sub-title="lastClientAdded.razonSocial"
                        icon="ni ni-square-pin"
                        class="mb-4 mb-xl-0">
                         <template slot="footer">
                            <span class="text-nowrap">Agregado el:</span>
                            <span class="text-nowrap"> {{getReadableDate(lastClientAdded.createdOn)}}</span>
                         </template>
                    </stats-card>
                </div>
                
            </div>
        </base-header>

        <div class="container-fluid mt--7">
            <div class="row">
                <div class="col">
                    <clients-table title="Clientes" :tableData="tableData"></clients-table>
                </div>
            </div>
        </div>

    </div>
</template>
<script>
  import ClientsTable from './Tables/ClientsTable';
  import moment from "moment";
  import Loading from 'vue-loading-overlay';
  import 'vue-loading-overlay/dist/vue-loading.css';
  export default {
    name: 'tables',
    components: {
      ClientsTable,
      Loading
    },
    methods: {
        getReadableDate(timestamp){
            moment.locale('es');
            let time = moment(timestamp, 'x')
            return time.format('LL');
        }
    },
    created(){
      const token = localStorage.getItem('id_token');
      this.isLoading = true;
      fetch(`${process.env.VUE_APP_VREMEC_API}/api/clients`, {
        method: 'GET',
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }).then(response => response.json())
        .then((data) => {
          this.tableData = data.Data.Items;
          let ts = this.tableData.map((client) => client.createdOn);
          let mostRecent = Math.max.apply(Math, ts);
          this.lastClientAdded = this.tableData.find((client) => client.createdOn === mostRecent);
          this.clientsCount = data.Data.Count.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
          this.isLoading = false;
        })
        .catch((e) => {
          console.error('error', e);
        });
    },
    data() {
      return {
        tableData: [],
        isLoading: false,
        clientsCount: '-',
        lastClientAdded: {
            razonSocial: '',
            createdOn: '',
            createdBy: ''
        }
      }
    }

  };
</script>
<style></style>
